import { CommonModule } from '@angular/common';
import { Component, ErrorHandler } from '@angular/core';

import { MdbNotificationRef } from 'src/lib/mdb5-adapted/public-api';

@Component({
  selector: 'lms-simple-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-notification" [class]="notificationClass">
      <div class="toast-header">
        <strong class="me-auto">{{ title }}</strong>
        <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
      </div>
      <div class="toast-body">
        {{ message }}
      </div>
      <div *ngIf="action" class="toast-actions">
        <button type="button" class="btn btn-sm btn-primary" (click)="onAction()">
          {{ action }}
        </button>
      </div>
    </div>
  `,
  styles: [`
    .toast-notification {
      min-width: 300px;
      background: white;
      border-radius: 0.25rem;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      overflow: hidden;
    }
    .toast-header {
      display: flex;
      align-items: center;
      padding: 0.5rem 0.75rem;
      background-color: rgba(0, 0, 0, 0.03);
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    .toast-body {
      padding: 0.75rem;
    }
    .toast-actions {
      padding: 0.5rem 0.75rem;
      border-top: 1px solid rgba(0, 0, 0, 0.05);
      text-align: right;
    }
    .btn-close {
      background: transparent;
      border: none;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1;
      color: #000;
      opacity: 0.5;
      cursor: pointer;
      padding: 0;
      margin-left: auto;
    }
    .btn-close:hover {
      opacity: 0.75;
    }
  `]
})
export class SimpleNotificationComponent implements ErrorHandler {
  message: string = '';
  title: string = 'Notification';
  action: string = '';
  notificationClass: string = '';

  constructor(public notificationRef: MdbNotificationRef<SimpleNotificationComponent>) {}

  close(): void {
    this.notificationRef.close();
  }

  handleError(error) {
    this.message = error.message || 'An unexpected error occurred';
    this.title = 'Error';
    this.action = 'Close';
    this.notificationClass = 'toast-error';


  }

  onAction(): void {
    this.notificationRef.close('action');
  }
}
